<template lang="html">
  <transition-group name="blur" tag="div">
    <img
      v-show="currentSrc === src"
      :src="src"
      class="blur-transition card-img"
      key="image"
      :style="{ 'border-radius': borderRadius }">
    </img>
  </transition-group>
</template>

<script>
  export default {
    props: {
      src: {
        type: String,
        default() {
          return '';
        },
      },
      borderRadius: {
        type: String,
        default() {
          return '0%';
        },
      },
    },
    data() {
      return {
        currentSrc: null
      };
    },
    mounted() {
      const hiResImg = new Image();
      hiResImg.onload = () => {
        this.currentSrc = this.src;
      };
      hiResImg.src = this.src;
    }
  };
</script>

<style scoped lang="stylus">
  /****** Import Global Stylus ******/
  @import '~app/global-stylus'

  .blur-transition
    transition: opacity linear .4s 0s
    -webkit-transition: opacity linear .4s 0s
    -moz-transition: opacity linear .4s 0s
    -o-transition: opacity linear .4s 0s
    opacity: 1

  .card-img
    min-width: 100%

  .blur-enter, .blur-leave
    opacity: 0
</style>



// WEBPACK FOOTER //
// plPreloader.vue?afe83d50